import type { PlanogramUI } from '../context/PlanogramAutomation';

export const checkIfExistLineChanged = (
    planogramsToChange: PlanogramUI[],
    planogramEdited: PlanogramUI[],
) => {
    const cloneOfPlanogramToChange = [...planogramsToChange];
    for (let i = 0; i < planogramEdited.length; i += 1) {
        const thereIsModifiedLine = planogramsToChange.findIndex(
            (item) => item.id === planogramEdited[i].id,
        );
        if (thereIsModifiedLine > -1) {
            cloneOfPlanogramToChange[thereIsModifiedLine] = planogramEdited[i];
        }
    }

    return cloneOfPlanogramToChange;
};
